import { useState, useEffect } from "react";

const API_BASE_URL = "https://api.itrustsecure.com";
function getToken() { return localStorage.getItem("itrust_token"); }
function getUserId() {
  try { return JSON.parse(localStorage.getItem("itrust_user"))?.id; } catch { return null; }
}

export function useMessageCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    async function fetchCount() {
      try {
        const token = getToken();
        const userId = getUserId();
        if (!token || !userId) return;

        const res = await fetch(`${API_BASE_URL}/conversations`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (!res.ok || !Array.isArray(data)) return;

        // Get last seen timestamp from localStorage
        const lastSeen = localStorage.getItem("itrust_messages_last_seen");
        const lastSeenDate = lastSeen ? new Date(lastSeen) : new Date(0);

        let unread = 0;
        for (const convo of data) {
          if (!convo.messages?.length) continue;
          // Count messages from others that are newer than last seen
          const newMessages = convo.messages.filter(msg =>
            msg.senderId !== userId &&
            new Date(msg.createdAt) > lastSeenDate
          );
          if (newMessages.length > 0) unread++;
        }

        setCount(unread);
      } catch { }
    }

    fetchCount();
    const interval = setInterval(fetchCount, 10000);
    return () => clearInterval(interval);
  }, []);

  return count;
}

// Call this when user opens the messages page
export function markMessagesAsSeen() {
  localStorage.setItem("itrust_messages_last_seen", new Date().toISOString());
}